import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges, ChangeDetectionStrategy, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { AnnouncementHttpService } from '@core/services/announcement-http.service';
import { environment } from './../../../environments/environment';
import { CommonModule } from '@angular/common';
import { SwiperOptions } from "swiper/types";
import { SwiperDirective } from '@core/directive/swiper.directive';
import { svgIconList } from '@shared/svg-icon-list';
import { IsLoggedIn } from '@core/entity/auth/state/auth.selectors';

@Component({
  selector: 'app-popup-announcement',
  imports: [CommonModule, SwiperDirective],
  templateUrl: './popup-announcement.component.html',
  styleUrls: ['./popup-announcement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: []
})
export class PopupAnnouncementComponent implements OnInit, OnDestroy {
  @ViewChild(SwiperDirective, { static: false }) swiperDirective?: SwiperDirective;

  content$: any[] = [];
  displayStyle = "none";

  isLoggedIn$: Observable<boolean>;

  private loggedInSubscription: Subscription;
  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination-popup', clickable: true },
    autoHeight: false,
    allowTouchMove: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    loop: true
  };

  environment = environment;

  isBrowser: boolean;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private domSanitizer:DomSanitizer,
    private announcementHttpService: AnnouncementHttpService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  @Input()
  message: any[];

  @Output()
  confirmed = new EventEmitter<boolean>();

  svg: any = svgIconList;

  skeletonLoading:boolean = true;

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.alert();
  }

  ngOnDestroy() {
    if (this.loggedInSubscription) {
      this.loggedInSubscription.unsubscribe();
    }
  }

  openPopup() {
    this.displayStyle = "block";
  }

  closePopup() {
    if (!this.isBrowser) { this.displayStyle = "none"; this.content$ = []; this.confirmed.emit(true); return; }
    let popup_ids = localStorage.getItem('popup_ids');
    if (popup_ids != undefined && popup_ids != null && JSON.parse(popup_ids).length > 0) {
      this.isLoggedIn$.subscribe(res => {
        if (res) {
            let popup_ids = JSON.parse(localStorage.getItem('popup_ids'))
            if (popup_ids.length == 0) {
              return;
            }
            const data = {
              popup_ids: JSON.parse(localStorage.getItem('popup_ids'))
            }
            this.announcementHttpService.updatePromotionPopupDialogLog(data).subscribe(() => {
              localStorage.removeItem('popup_ids');
            });
          }
      });

      let announcementPopList = JSON.parse(localStorage.getItem('announcements_pop')).filter((x: any) => JSON.parse(popup_ids).includes(x.id));
      let announcementPopCodes = announcementPopList.map(function(i: any) {
        return i['code'];
      });

      if (announcementPopCodes.length > 0 && localStorage.getItem('dialog') != null) {
        if (announcementPopCodes.includes(localStorage.getItem('dialog'))) {
          localStorage.removeItem('dialog');
          localStorage.setItem('insufficient_balance_popup', '0');
        }
      }
    }
    
    this.displayStyle = "none";
    this.content$ = [];
    this.cdr.detectChanges();
    this.confirmed.emit(true);
  }

  doNotShowAgain(item: any, event: any) {
    if (!this.isBrowser) return;
    let dismissedPopups: number[] = JSON.parse(localStorage.getItem('dismissed_popups') || '[]');
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      if (!dismissedPopups.includes(item.id)) {
        dismissedPopups.push(item.id);
        localStorage.setItem('dismissed_popups', JSON.stringify(dismissedPopups));
        this.swiperDirective?.swiperInstance?.slideNext();
      }
    } else {
      dismissedPopups = dismissedPopups.filter(id => id !== item.id);
      localStorage.setItem('dismissed_popups', JSON.stringify(dismissedPopups));
    }
  }
  

  private alert() {
    if (!this.isBrowser) return;

    //checking login
    this.isLoggedIn$ = this.store.pipe(select(IsLoggedIn));

    this.content$ = [];
    this.cdr.detectChanges();
    const currentLanguageCode = localStorage.getItem('language_code');
    const dismissedPopups = JSON.parse(localStorage.getItem('dismissed_popups') || '[]');
    
    if (this.message.length > 0) {
      if (this.loggedInSubscription) {
        this.loggedInSubscription.unsubscribe();
      }

      this.loggedInSubscription = this.isLoggedIn$.pipe(take(1)).subscribe(res => {
        this.content$ = [];

        if (res) {
          this.message.map(content => {
            let item = content[0];
            let language_code = (item['locale_name'] as string ).split("_", 2);

            // Skip popups that have been marked as "Do Not Show Again"
            if (!dismissedPopups.includes(item["id"])) {
              if(currentLanguageCode == language_code[1] && (item['session'] == 1 || item['session'] == 3)){
                if(item['title'] || item['content'] || ( item['media_type'] && item['desktop_link'] ) )  this.content$.push(item);
              }
            }
          });
        } else {
          this.message.map(content => {
            let item = content[0];
            let language_code = (item['locale_name'] as string ).split("_", 2);
            if(currentLanguageCode == language_code[1] && (item['session'] == 1 || item['session'] == 2)){
              if(item['title'] || item['content'] || ( item['media_type'] && item['desktop_link'] ))  this.content$.push(item);
            }
          });
        }
        this.cdr.markForCheck();
        if(this.content$.length > 0) this.openPopup();
        setTimeout(() => {
          this.skeletonLoading = false;
          this.cdr.detectChanges();
        }, 500)
      });      
    }
  }
  
  onRedirect(item: any, link: string){
    this.isLoggedIn$.subscribe(res => {
      if (res) {
        const data = {
          popup_ids: [item.id]
        }
        this.announcementHttpService.updatePromotionPopupDialogLog(data).subscribe(() => {});
      }
    });

    if (link !== ''){
      if (link.includes('/external?link=') && this.isBrowser) {
        var redirectTO = link.replace('/external?link=','');
        window.open(redirectTO, '_blank');
      } else {
        this.router.navigateByUrl(link);
      }
      this.closePopup();
    }
  }

  getUrl(url: any) {
    if(url.includes("youtube") && url.includes("watch?v=")){
      url = url.replace('watch?v=', 'embed/') + '?controls=1&mute=1&showinfo=0&rel=0&autoplay=1&loop=1';
    }
    else if(url.includes("youtube")) {
      url = url + '?controls=1&mute=1&showinfo=0&rel=0&autoplay=1&loop=1';
    }
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  displayVideoType(url: any) {
    if(url.includes("youtube")){
      return 'youtube'
    }else{
      return 'video'
    }
  }

  checkPopupList() {
    if (localStorage.getItem('announcements_pop') !== null) {
      return true;
    }
    else {
      return false;
    }
  }
}
